import React, { ReactElement } from 'react'
import styled from 'styled-components'

interface MessageProps {
  boldText: string
  normalText: string
  children: React.ReactNode
  noMargin?: boolean
}

export const Message = (props: MessageProps): ReactElement => {
  const { boldText, normalText, children, noMargin } = props
  return (
    <FlexColumn>
      <Flex>
        <BoldText>{boldText}.&ensp;</BoldText>
        <NormalText>{normalText}</NormalText>
      </Flex>
      <PartsList noMargin={noMargin}>
        <NormalText>{children}</NormalText>
      </PartsList>
    </FlexColumn>
  )
}

const NormalText = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${(p) => p.theme.colors.almostBlack};
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
`

const BoldText = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${(p) => p.theme.colors.almostBlack};
`
interface PartsListProp {
  noMargin: boolean
}

const PartsList = styled.div<PartsListProp>`
  padding-left: ${(p) => (p.noMargin ? '0px' : '2rem')};
  min-width: 0;
  max-width: 100%;
`

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  text-align: start;
  padding-bottom: 1rem;
  min-width: 0;
  max-width: 100%;
`

const Flex = styled.div`
  display: flex;
`
